import React from 'react';
import './HowItWorks.css';

const HowItWorks = () => {
    const steps = [
        {
            number: '01',
            title: 'Take Our Quiz',
            description: 'Answer 10 simple questions about your symptoms, lifestyle, and wellness goals. It only takes 2 minutes.',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9 12h3.75M9 15h3.75M9 18h3.75m3 .75H18a2.25 2.25 0 002.25-2.25V6.108c0-1.135-.845-2.098-1.976-2.192a48.424 48.424 0 00-1.123-.08m-5.801 0c-.065.21-.1.433-.1.664 0 .414.336.75.75.75h4.5a.75.75 0 00.75-.75 2.25 2.25 0 00-.1-.664m-5.8 0A2.251 2.251 0 0113.5 2.25H15c1.012 0 1.867.668 2.15 1.586m-5.8 0c-.376.023-.75.05-1.124.08C9.095 4.01 8.25 4.973 8.25 6.108V8.25m0 0H4.875c-.621 0-1.125.504-1.125 1.125v11.25c0 .621.504 1.125 1.125 1.125h9.75c.621 0 1.125-.504 1.125-1.125V9.375c0-.621-.504-1.125-1.125-1.125H8.25zM6.75 12h.008v.008H6.75V12zm0 3h.008v.008H6.75V15zm0 3h.008v.008H6.75V18z" />
                </svg>
            ),
        },
        {
            number: '02',
            title: 'Get Personalized Matches',
            description: 'Our algorithm analyzes your responses to find supplements proven to work for your specific needs.',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M9.813 15.904L9 18.75l-.813-2.846a4.5 4.5 0 00-3.09-3.09L2.25 12l2.846-.813a4.5 4.5 0 003.09-3.09L9 5.25l.813 2.846a4.5 4.5 0 003.09 3.09L15.75 12l-2.846.813a4.5 4.5 0 00-3.09 3.09zM18.259 8.715L18 9.75l-.259-1.035a3.375 3.375 0 00-2.455-2.456L14.25 6l1.036-.259a3.375 3.375 0 002.455-2.456L18 2.25l.259 1.035a3.375 3.375 0 002.456 2.456L21.75 6l-1.035.259a3.375 3.375 0 00-2.456 2.456zM16.894 20.567L16.5 21.75l-.394-1.183a2.25 2.25 0 00-1.423-1.423L13.5 18.75l1.183-.394a2.25 2.25 0 001.423-1.423l.394-1.183.394 1.183a2.25 2.25 0 001.423 1.423l1.183.394-1.183.394a2.25 2.25 0 00-1.423 1.423z" />
                </svg>
            ),
        },
        {
            number: '03',
            title: 'Start Your Journey',
            description: 'Explore your recommendations, read detailed guides, and begin feeling like yourself again.',
            icon: (
                <svg viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="1.5">
                    <path strokeLinecap="round" strokeLinejoin="round" d="M2.25 18L9 11.25l4.306 4.307a11.95 11.95 0 015.814-5.519l2.74-1.22m0 0l-5.94-2.28m5.94 2.28l-2.28 5.941" />
                </svg>
            ),
        },
    ];

    return (
        <section className="how-it-works" id="how-it-works">
            <div className="container">
                <div className="hiw-header">
                    <span className="section-badge">How It Works</span>
                    <h2 className="section-title">
                        A proven process to find
                        <span className="gradient-text"> your perfect match</span>
                    </h2>
                    <p className="section-subtitle">
                        Simple, personalized, and backed by science
                    </p>
                </div>

                <div className="hiw-timeline">
                    {steps.map((step, index) => (
                        <div key={index} className={`hiw-step ${index % 2 === 1 ? 'hiw-step-reverse' : ''}`}>
                            <div className="hiw-step-content">
                                <span className="hiw-step-number">{step.number}</span>
                                <h3 className="hiw-step-title">{step.title}</h3>
                                <p className="hiw-step-desc">{step.description}</p>
                                <button type="button" className="hiw-step-link">
                                    Learn more
                                    <svg viewBox="0 0 20 20" fill="currentColor">
                                        <path fillRule="evenodd" d="M10.293 3.293a1 1 0 011.414 0l6 6a1 1 0 010 1.414l-6 6a1 1 0 01-1.414-1.414L14.586 11H3a1 1 0 110-2h11.586l-4.293-4.293a1 1 0 010-1.414z" clipRule="evenodd" />
                                    </svg>
                                </button>
                            </div>
                            <div className="hiw-step-visual">
                                <div className="hiw-step-icon">{step.icon}</div>
                            </div>
                            {index < steps.length - 1 && <div className="hiw-connector" />}
                        </div>
                    ))}
                </div>
            </div>
        </section>
    );
};

export default HowItWorks;
